/* eslint-disable max-len */

import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { distributorService } from '../../service/distributor.service';


export default function VirtualPaymentInstructions({setvirtualInstructions}) {
    const [distributorDetails,setdistributorDetails] = useState(null)

    const getVirtualPaymentDetails = async() => {
        const res = await distributorService.Getprofile();
        if (!res.error && res.data.success_status) {
            setdistributorDetails(res?.data?.data);
        }
    }
    useEffect(()=>{
        getVirtualPaymentDetails()
    },[])
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01]
            }}  className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-3 pointer-events-none" style={{margin: 'auto'}}>
            <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current sm:pt-11 pt-8 pb-6 sm:px-[30px] px-6">
                <div className="modal-header flex flex-shrink-0 items-center rounded-t-md relative">
                    <span className="mr-[50px] cursor-pointer" onClick={()=>setvirtualInstructions(false)}>
                        <img src="/images/close-icon-virtual-payment.svg" alt=""/>
                    </span>
                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                        Virtual Payment Instructions
                    </h5>
                </div>
                <div className="sm:pt-8 pt-6">
                    <ol className="list-decimal">
                        <li className="text-sm font-normal text-[#090406]">
                            Please Login to your internet banking portal or open your bank’s mobile app
                        </li>
                        <li className="text-sm font-normal text-[#090406] mt-2">
                            Add your virtual account details ( for the first transfer) along with the IFSC code as Beneficiary.
                        </li>
                        <li className="text-sm font-normal text-[#090406] mt-2">
                            Note your <span className="font-semibold">Virtual Account Number:</span> {distributorDetails?.virtual_account_info?.receivers[0]?.account_number}, <span className="font-semibold">IFSC Code:</span> {distributorDetails?.virtual_account_info?.receivers[0]?.ifsc}
                        </li>
                        <li className="text-sm font-normal text-[#090406] mt-2">
                            Input the amount you wanted to transfer and initiate the transfer using IMPS / NEFT or RTGS
                        </li>
                    </ol>
                </div>
                <div className="w-full mt-[30px]">
                    <Link to={`/orders`} className="w-full flex justify-center">
                        <button type="button" className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                            Go to Order
                        </button>
                    </Link>
                </div>
            </div>
        </motion.div>
    )
}
